export default {
  main: {
    title: 'Проверка версии',
    language: 'Русский',
    intro:
      'Проверка версии выполняется путем сопоставления хэш-значений MD5 или SHA256 между версиями. Пожалуйста, убедитесь, что вы загружаете кошелек TokenPocket через официальные каналы, чтобы избежать обмана. Для получения инструкций о том, как получить хэш-значения MD5 или SHA256 для версии, пожалуйста, ',
    tutorial: 'обратитесь к руководству >',
    system: 'ОС',
    android: 'Android',
    ios: 'iOS',
    version: 'Версия',
    allVersion: 'Все',
    appChannel: 'Канал приложения',
    developer: 'разработчик',
    allChannel: 'Все',
    md5: 'MD5',
    sha256: 'SHA256',
    log: 'Журнал версий',
    check: 'Подробнее',
    versionLog: 'Журнал версий',
    confirm: 'Подтвердить',
    aboutIOS: 'О версии iOS',
    IOSDesc:
      'Для версий iOS мы предлагаем наше приложение только в App Store. Только приложения, загруженные из App Store, могут быть правильно установлены. Поэтому, используя устройства Apple, пожалуйста, убедитесь, что вы аутентифицируете App Store как единственный канал загрузки.',
    IOSDesc_2:
      'Разработчиком версии, загруженной из App Store до 8 октября 2022 года, является TOKENPOCKET FOUNDATION LTD, которая является ранней версией, разработанной TokenPocket. Это легитимный кошелек, который можно использовать нормально, но услуга обновления временно приостановлена.',
    aboutAndroid: 'О версии Android',
    androidDesc: 'В настоящее время TokenPocket предлагает каналы загрузки для Android, включая официальный веб-сайт, Google Play Store, Samsung App Store, Huawei AppGallery, OPPO App Store и Vivo App Store. В некоторых приложениях из магазинов невозможно получить установочный файл APK во время загрузки, поэтому нельзя выполнить проверку на соответствие MD5 или SHA256. Поэтому, при загрузке обязательно проверяйте информацию о разработчике и справочную информацию ниже!',
    IOSAppName: 'Название приложения:',
    TPWallet: 'TP Wallet',
    AppIcon: 'Иконка приложения:',
    AppDeveloper: 'Разработчик:',
    downloadLink: 'Ссылка для загрузки:',
    copied: 'Скопировано!',
    versionVerification: 'Version Verification',
  },
  follow: {
    title: 'Подписывайтесь на нас',
    desc1: 'Сотрудники TokenPocket не будут отправлять вам личные сообщения!',
    desc2:
      'Осторожность! Вы входите в сообщество TokenPocket, возможно, кто-то выдает себя за нас, чтобы отправлять вам личные сообщения! Имейте в виду, что любой, кто отправляет личные сообщения, может быть мошенником! Мы никогда не свяжемся с вами первыми!',
    desc3: 'Понятно, вводите',
  },
  COMMON: {
    LAYOUT: {
      features: 'Особенности',
      products: 'Продукты',
      buyCryptoFooter: 'Покупка',
      mobileWallet: 'Мобильный кошелек',
      mobileWalletDesc: 'Крипто и DeFi мобильный кошелек на блокчейне.',
      hardwareWallet: 'Аппаратный кошелек',
      hardwareWalletDesc: 'Получите KeyPal, чтобы защитить ваши активы.',
      extensionWallet: 'Расширение кошелька',
      extensionWalletDesc: 'Удобный кошелек для вашего компьютера.',
      desktop: 'Desktop Wallet',
      fiveDegrees: '5Degrees',
      versionVerification: 'Проверка версии',
      versionVerificationDesc: 'Проверьте ваш кошелек.',
      approvalDetector: 'Обнаружение одобрений',
      approvalDetectorDesc: 'Просматривайте и отменяйте одобрения ваших токенов.',
      tokenSecurity: 'Безопасность токенов',
      tokenSecurityDesc: 'Проверьте безопасность токена по его адресу контракта.',
      keyGenerator: 'Генератор ключей',
      keyGeneratorDesc: 'Генерация случайных публичных и приватных ключей для сетей.',
      tokenProfile: 'Профиль токена',
      tokenProfileDesc: 'Узнайте всю информацию о токене.',
      tokenClaim: 'Запрос токенов',
      tokenClaimDesc: 'Запросите ваш airdrop.',
      easyInscription: 'Легкая надпись',
      easyInscriptionDesc: 'Безопасный инструмент для надписей.',
      nostrAssetsBatchSender: 'NostrAssets BatchSender',
      nostrAssetsBatchSenderDesc: 'Инструмент массовой отправки для NostrAssets.',
      BATCH_SENDER: 'BatchSender',
      BATCH_SENDER_DESC: 'Отправляйте токены нескольким получателям одновременно.',
  
      trade: 'Торговля',
      swap: 'Обмен',
      swapDesc: 'Торгуйте по лучшим ценам.',
      bridge: 'Мост',
      bridgeDesc: 'Легко переводите активы с одной цепочки на другую.',
      buyCrypto: 'Покупка',
      buyCryptoDesc: 'Покупайте криптовалюту с помощью кредитных карт.',
      market: 'Рынок',
      marketDesc: 'Мгновенные данные для обнаружения популярных токенов.',
  
      information: 'Информация',
      blockchainGuide: 'Руководство по блокчейну',
      tronWallet: 'Руководство по TRON',
      iostWallet: 'Руководство по IOST',
      tpMan: 'ТП-мужчина',
  
      developers: 'Разработчики',
      github: 'Github (TP-Lab)',
      devCenter: 'Центр разработки',
      developersDesc: 'Документация для разработчиков TokenPocket.',
      subToken: 'Отправить токен',
      subTokenDesc: 'Отправьте ваш токен.',
      subDApp: 'Отправить DApp',
      subDAppDesc: 'Отправьте ваше DApp, и оно будет отображено после аудита.',
      subNFT: 'Отправить NFT',
      subNFTDesc: 'Отправьте ваши NFT и произведения искусства.',
      subChain: 'Отправить цепочку',
      subChainDesc: 'Отправьте вашу блокчейн.',
      bugBounty: 'Bug Bounty',
  
      tools: 'Инструменты',
  
      build: 'Разработка',
  
      learn: 'Учиться',
  
      explorer: 'Проводник',
  
      company: 'Компания',
      about: 'О',
      careers: 'Карьера',
      pressKit: 'Бренд-кит',
      swagShop: 'Магазин сувениров',
  
      support: 'Поддержка',
      helpCenter: 'Центр помощи',
      helpCenterDesc: 'Ваши ресурсы для получения ответов и помощи.',
      contactUs: 'Свяжитесь с нами',
      contactUsDesc: 'Делитесь своими предложениями и задавайте любые вопросы.',
      forum: 'Форум',
      forumDesc: 'Наслаждайтесь беседами с членами сообщества.',
  
      legal: 'Юридический',
      privacyPolicy: 'Политика конфиденциальности',
      terms: 'Условия использования',
  
      toHome: 'Дом',
      defiWallet: 'Кошелек DeFi',
      ETHWallet: 'Кошелек Эфириума',
      ethWallet: 'ETH-кошелек',

      dappStore: 'DApp магазин'
    }
  }
};
